import cn from "classnames";
import styles from "./CommonSelector.module.scss";
import { memo } from "react";
import { Select } from "../Select/Select";
import { SelectProps as AntSelectProps } from "antd";
import { WarningOutlined } from "@ant-design/icons";

export interface ICommonValue<T> {
  readonly id: T; //string | number;
  readonly text: string;
  readonly additionalValue?: string; // это , например, теги или дом инфо строкой
}

type ICommonSelectorProps<T> = {
  readonly outlined?: boolean;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly disabledHint?: string;
  readonly id?: string;
  readonly options: ICommonValue<T>[];
  readonly name?: string;
  readonly hasCleanUp?: boolean;
  readonly hasPrevText?: boolean;
  readonly currentValue?: ICommonValue<T>;
  readonly reset?: number;
  // дефолтное значение , которое должно быть у селекторов некоторых (типа ВСЕ и тд)
  readonly clearedValue?: ICommonValue<T>;
  readonly showSearch?: boolean;
  readonly error?: string;

  onChange?(id?: T): void;
  onCleanUp?(): void;
  renderOption?(id: number | string): React.ReactNode;
} & Omit<AntSelectProps<ICommonValue<T>>, "onChange" | "prefix">;

function CommonSelector<T extends string | number | undefined>({
  error,
  ...props
}: ICommonSelectorProps<T>) {

  console.log("CommonSelector props", props);

  return (
    <div className={cn(styles.wrapper, props.className)} tabIndex={-1}>
      <Select
        prefix={
          error ?
            <WarningOutlined
              style={{ color: '#ff0000' }}
              title={error}
            /> : null
        }
        filterOption={props.filterOption}
        showSearch={props.showSearch}
        size="small"
        popupMatchSelectWidth={props.popupMatchSelectWidth}
        allowClear={props.hasCleanUp}
        disabled={props.disabled}
        label={<span className={styles.label}>{props.name}</span>}
        id={props.id}
        value={props.currentValue?.id}
        options={props.options.map(item => ({
          label: item.text,
          value: item.id,
        }))}
        optionRender={(item) =>
          props.renderOption ? props.renderOption(item.value!) : item.label
        }
        onClear={props.onCleanUp}
        onChange={props.onChange}
        outlined={props.outlined}
      />
    </div>
  );
}

export default memo(
  CommonSelector,
  (prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);
